export default "static/media/quickstart.941d43d.svg"